import { render } from "./USWDSRadioForm.vue?vue&type=template&id=e9a0a680"
import script from "./USWDSRadioForm.vue?vue&type=script&lang=js"
export * from "./USWDSRadioForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/wma/osd/decap/configuration-depot/configuration-depot-application/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__